<template>
  <div class="form-check">
    <input
      :id="id"
      class="form-check-input"
      type="checkbox"
      :name="name"
      :value="value"
      :checked="isChecked"
      @change="handleChange"
    />
    <label :for="id" class="custom-control-label text-lg" :class="$attrs.class">
      {{ label }}
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: "SoftCheckbox",
  props: {
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      required: true,
    },
    modelValue: {
      type: [Array, Boolean],
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    isChecked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value);
      }
      return this.modelValue;
    },
  },
  emits: ["update:modelValue"],
  methods: {
    handleChange(event) {
      const checked = event.target.checked;

      if (Array.isArray(this.modelValue)) {
        let newValue = [...this.modelValue];
        if (checked) {
          if (!newValue.includes(this.value)) {
            newValue.push(this.value);
          }
        } else {
          newValue = newValue.filter((val) => val !== this.value);
        }
        this.$emit("update:modelValue", newValue);
      } else {
        this.$emit("update:modelValue", checked);
      }
    },
  },
};
</script>
